import { useEffect, useState } from "react";
import styles from '../styles/Footer.module.css';
import Link from 'next/link';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'next/image';
import * as LIB from '../lib/common';
import { commonUrl } from "../pages/api/config";

const Footer = () => {
    const [footerData, setFooterData] = useState([]);
    const [viewCount, setViewCount] = useState({});
    const [curYear, setCurYear] = useState();
    useEffect(() => {
        getFooterData();
        getCurYearData()
    }, []);

    const getFooterData = async () => {
        const res = await fetch(commonUrl.headerFooter);
        const resData = await res.json();
        setFooterData(resData.footer);

        //format & set view count data
        let viewCountData = {
            overall: (resData.overall).toLocaleString('en-US'),
            today: (resData.web + resData.app + resData.podcast).toLocaleString('en-US')
        }
        setViewCount(viewCountData);
    }

    const getCurYearData = () => {
        const d = new Date();
        let year = d.getFullYear();
        setCurYear(year);
    }

    const renderLeftRow = () => {
        let rows = [];
        if (footerData[0]) {
            let data = footerData[0];
            rows.push(<div className={styles.title} key='keyA0'>{data.title}</div>);
            //sub items
            let subitems = data.sub_items;
            if (subitems) {
                for (let l = 0; l < subitems.length; l++) {
                    const item = subitems[l];
                    rows.push(
                        <a href={LIB.getBasepath(item.link)} className={styles.inherit} target='_blank' key={`keyA${l + 1}`}>
                            <div className={styles.leftRowTitle}>{item.title}</div>
                        </a>
                    );
                }
            }
            //wrap the result
            return (
                <Col xl={4} md={4} xs={12}>
                    <div className={styles.alignCenter}>
                        <div className={styles.floatLeft}>
                            {rows}

                            <div className={styles.offeringImg}>
                                <a href={LIB.getBasepath('/page/offerings')} target='_blank'>
                                    <Image
                                        src={LIB.getBasepath('/images/banner/offering.png')}
                                        alt="圖片"
                                        width={120}
                                        height={72}
                                    // layout="responsive"
                                    />
                                </a>
                            </div>

                            <div className={styles.social_link}>
                                <a href='https://www.youtube.com/c/ziondaily4794' className={styles.inherit} target='_blank'><i className="fab fa-youtube"></i></a>
                                &nbsp;
                                <a href='https://www.facebook.com/ziondaily' className={styles.inherit} target='_blank'><i className="fab fa-facebook-square"></i></a>
                                &nbsp;
                                <a href='https://twitter.com/ziondaily4794' className={styles.inherit} target='_blank'><i className="fab fa-twitter"></i></a>
                                &nbsp;
                            </div>

                            <div className={styles.viewCountHolder}>
                                <div className={styles.viewCountTitle}>瀏覽數據</div>
                                <div className={styles.viewCountTag}>累計：<span className={styles.viewCount}>{viewCount.overall}</span> 人次</div>
                                <div className={styles.viewCountTag}>今天：<span className={styles.viewCount}>{viewCount.today}</span> 人次</div>
                                {/* <div className={styles.viewCountTag}>App：<span className={styles.viewCount}>{typeof(viewCount.app)}</span> 人次</div>
                <div className={styles.viewCountTag}>Podcast：<span className={styles.viewCount}>{viewCount.podcast}</span> 人次</div> */}
                            </div>
                        </div>
                    </div>
                </Col>
            );
        }
        return <></>;
    }

    const renderOtherRow = (data, form) => {
        let rows = [];
        if (data) {
            rows.push(<div className={styles.title} key='keyB0'>{data.title}</div>);
            //sub items
            let subitems = data.sub_items;
            if (subitems) {
                for (let l = 0; l < subitems.length; l++) {
                    const item = subitems[l];
                    rows.push(
                        <Row className={styles.row} key={`keyB${l + 1}`}>
                            <Col lg={form == 'square' ? 2 : 3} xs={3} style={{ padding: 0 }}>
                                <Image
                                    src={item.img}
                                    alt="圖片"
                                    sizes="100vw"
                                    width={form == 'square' ? 200 : 200}
                                    height={form == 'square' ? 200 : 117}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                    }}
                                />
                            </Col>
                            <Col lg={form == 'square' ? 10 : 9} xs={9} style={{ padding: 0 }}>
                                <div className={styles.rowTitle}>
                                    <a href={LIB.getBasepath(item.link)} className={styles.inherit} target='_blank'>
                                        {item.title}
                                    </a>
                                </div>
                                <div className={styles.rowTxt}>{item.subtitle}</div>
                            </Col>
                        </Row>
                    )
                }
            }
            return (
                <Col xl={4} md={4} xs={12}>
                    <div className={styles.alignCenter}>
                        <div className={styles.floatLeft}>
                            <Container style={{ padding: 0 }}>
                                {rows}
                            </Container>
                        </div>
                    </div>
                </Col>
            );
        }
        return <></>;
    }

    return (
        <div className={styles.fullWidth}>
            <script defer src="https://use.fontawesome.com/releases/v5.15.4/js/all.js"></script>
            <div className="viewport">
                <Container fluid className={styles.innerHolder}>
                    <Row>
                        {renderLeftRow()}

                        {renderOtherRow(footerData[1])}

                        {renderOtherRow(footerData[2], 'square')}
                    </Row>
                </Container>
            </div>
            <div className={styles.footerBottom}>Copyright © 2004 - {curYear} ZionDaily.com All Rights Reserved.</div>
        </div>
    );
}

export default Footer;